module.exports = __webpack_public_path__ + "img/card.e24d50c1.png";